import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/authentication/auth.guard';
import { SpotlightRootComponent } from '../spotlight/components/spotlight-root/spotlight-root.component';
import { RedCarpetComponent } from '../spotlight/red-carpet/red-carpet.component';
import { AboutComponent } from './about/about.component';
import { CinejoyHomepageComponent } from './cinejoy-homepage/cinejoy-homepage.component';
import { GroupShareInfoPageComponent } from './group-share-info-page/group-share-info-page.component';
import { HowToTicketsComponent } from './how-to-tickets/how-to-tickets.component';
import { HowToGsComponent } from './how-to-gs/how-to-gs.component';
import { FeaturedGuestsComponent } from '../creatics/featured-guests/featured-guests.component';
import { AwardsComponent } from './awards/awards/awards.component';
import { AllAwardsComponent } from './awards/all-awards/all-awards.component';
import { JuryComponent } from './awards/jury/jury.component';

const routes: Routes = [
  {
    path: '',
    component: CinejoyHomepageComponent,
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'group-share-info-page',
    component: HowToGsComponent,
  },
  {
    path: 'passport',
    loadChildren: () => import('../passport/passport.module').then(m => m.PassportModule),
  },
  {
    path: 'screening-parties',
    loadChildren: () => import('../screening-parties/screening-parties.module').then(m => m.ScreeningPartiesModule),
  },
  {
    path: 'showcase',
    loadChildren: () => import('../showcase/showcase.module').then(m => m.ShowcaseModule),
  },
  {
    path: 'showcase/archive',
    loadChildren: () => import('../showcase/showcase.module').then(m => m.ShowcaseModule),
  },
  {
    path: 'premiere',
    loadChildren: () => import('../spotlight/spotlight.module').then(m => m.SpotlightModule),
  },
  {
    path: 'spotlight-root/:id/:premiere-name',
    component: SpotlightRootComponent,
  },
  {
    path: 'premiere/redcarpet/:id/:premiere-name',
    component: RedCarpetComponent,
    canActivate: [AuthGuard],
    data: { animation: 'RedCarpetPage' }
  },
  {
    path: 'premiere/theater',
    loadChildren: () => import('../theater/theater.module').then(m => m.TheaterModule),
  },
  {
    path: 'group-sharing',
    loadChildren: () => import('../group-sharing/group-sharing.module').then(m => m.GroupSharingModule),
  },
  {
    path: 'featured-guests',
    component: FeaturedGuestsComponent
  },
  {
    path: 'how-to',
    component: HowToTicketsComponent,
  },
  {
    path: 'awards',
    component: AwardsComponent,
  },
  {
    path: 'all-awards',
    component: AllAwardsComponent,
  },
  {
    path: 'jury',
    component: JuryComponent,
  },
  {
    path: 'archive/awards',
    component: AwardsComponent,
  },
  {
    path: 'archive/all-awards',
    component: AllAwardsComponent,
  },
  {
    path: 'archive/jury',
    component: JuryComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CinejoyRoutingModule { }
